import React, { useState } from 'react';
import { TooltipStatic } from './TooltipStatic';
export const Tooltip = ({ reference, placement = 'bottom', strategy = 'absolute', offset = [0, 10], withPadding = true, fluid = false, children, }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (React.createElement(TooltipStatic, null,
        React.createElement(TooltipStatic.Reference, { onMouseEnter: () => setIsOpen(true), onMouseLeave: () => setIsOpen(false), onTouchStart: () => setIsOpen(true), onTouchEnd: () => setIsOpen(false), "data-testid": "Tooltip" },
            reference,
            isOpen && children && (React.createElement(TooltipStatic.Body, { placement: placement, strategy: strategy, offset: offset, withPadding: withPadding, fluid: fluid }, children)))));
};
//# sourceMappingURL=Tooltip.js.map